import { Pipe, PipeTransform } from '@angular/core';
import { Lib } from '@core/lib';

@Pipe({ name: 'YesNo' })
export class YesNoPipe implements PipeTransform {
    transform(value: boolean): string {
      return Lib.yesNo(value);
    }
}
